import RestrictionsStrategyBase from './restrictions_strategy_base';
import Event from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';
import IRestrictionsPool from '../pool/restrictions_pool_interface';

export default class AnonymousRestrictionsStrategy extends RestrictionsStrategyBase {
  static CLASS = 'AnonymousRestrictionsStrategy';
  private _anonymousRestrictionsUri: string;
  private _restrictionsByAction: any[];
  private _restrictionsPool: IRestrictionsPool = null;


  init(params) {
    super.init(params);
    this._anonymousRestrictionsUri = params.anonymousRestrictionsUri;
    this._restrictionsByAction = params.anonymousRestrictions && params.anonymousRestrictions.RestrictionsByAction;
  }


  public getRestrictionsPool(): IRestrictionsPool {
    if(!this._restrictionsPool) {
      this._restrictionsPool = this._createRestrictionsPool(this._restrictionsByAction);
    }
    return this._restrictionsPool;
  }

  doAsyncJobs() {

    if(this._restrictionsByAction) {
      return Promise.resolve();
    }

    const skinService = this._serviceFactory.skinService();
    const request = {
      BrandId: skinService.getBrandID(),
      SubBrandId: skinService.getSubBrandID(),
      ProductPackage: skinService.getProductPackageID(),
      ClientVersion: skinService.getVersion()
    };

    return this._serviceFactory.http2Service()
      .post(this._anonymousRestrictionsUri, request)
      .then(data => {
        this._restrictionsByAction = data && (data as any).RestrictionsByAction;
        if(!this._serviceFactory.oAuth2Service().isAuthorized()) {
          Event.fire(SYSTEM_EVENTS.RESTRICTIONS_CHANGED);
        }
      });

  }

  //Used by automation team
  public setRestrictions(restrictions: any): void {
    if(restrictions.anonymousRestrictions) {
      this._restrictionsPool = this._createRestrictionsPool(restrictions.anonymousRestrictions.RestrictionsByAction);
    }
  }
}